import { FormGroup, Input, Label } from 'reactstrap';
import React from 'react';
import './DateInputGroup.scss';
import { PropTypes } from 'prop-types';
import { Trans } from 'react-i18next';
import { FormSection } from '../..';

const DateInputGroup = ({ title, startDate, endDate, setStartDate, setEndDate }) => (
  <FormSection title={title}>
    <FormGroup>
      <Label for={`${title}-startDate`}>
        <Trans i18nKey="date.startDate" />
      </Label>
      <Input
        type="date"
        id={`${title}-startDate`}
        onChange={event => setStartDate(event.target.value)}
        value={startDate}
      />
    </FormGroup>
    <FormGroup>
      <Label for={`${title}-endDate`}>
        <Trans i18nKey="date.endDate" />
      </Label>
      <Input
        type="date"
        id={`${title}-endDate`}
        className="endDate"
        onChange={event => setEndDate(event.target.value)}
        value={endDate}
      />
    </FormGroup>
  </FormSection>
);

DateInputGroup.propTypes = {
  title: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  setStartDate: PropTypes.func.isRequired,
  setEndDate: PropTypes.func.isRequired,
};

export { DateInputGroup };
